import React from 'react'
import GaiaLogo, { TYPE_WHITE } from '../GaiaLogo/index'
import { H2, H6 } from '../Heading/index'
import Button, { TYPES } from '../Button/index'
import { URL_ACCOUNT_CREATION, URL_CART_ACCOUNT_CREATION_CREATE } from '../../services/url/constants'
import { UNAVAILABLE_REASON } from '../../services/share/index'

/**
 * The view for 'watched too many videos' state
 * @param {Object} props - The props
 * @param {Boolean} props.isLoggedIn - The value indicating if user is logged in
 * @param {Map} props.staticText - The static text
 * @param {String} props.unavailableReason - The unavailable reason value
 * @returns {JSX.Element} VideoLimitView
 */

function SharePageVideoLimitView (props) {
  const {
    isLoggedIn,
    staticText,
    unavailableReason,
    showRenew,
  } = props

  const isEmailLimitExceeded = unavailableReason === UNAVAILABLE_REASON.EMAIL_VIEW_LIMIT_EXCEEDED
  const title = isEmailLimitExceeded
    ? staticText.get('limitViewTitle')
    : staticText.get('expiredViewTitle')

  const text1 = isEmailLimitExceeded
    ? staticText.get('limitViewText1')
    : staticText.get('expiredViewText1')

  const text2 = isEmailLimitExceeded
    ? staticText.get('limitViewText2')
    : staticText.get('expiredViewText2')

  return (
    <div className="share-page__video-limit-view">
      <div className="share-page__video-limit-view-container">
        <div className="share-page__video-limit-view-section">
          <GaiaLogo type={TYPE_WHITE} />
          <H2>{title}</H2>
          <p className="share-page__video-limit-view-text">{text1}</p>
          <p className="share-page__video-limit-view-text">{text2}</p>
        </div>
        <div className="share-page__video-limit-view-section">
          {isLoggedIn
            ? <Button
              className="share-page__video-limit-view-button"
              type={TYPES.ROYAL}
              url={URL_CART_ACCOUNT_CREATION_CREATE}
            >
              {showRenew ? staticText.get('renewMembership') : staticText.get('joinGaia')}
            </Button>
            : <>
              <div className="share-page__video-limit-view-anonymous">
                <H6>{staticText.get('joinGaiaLine1')}</H6>
                <p>{staticText.get('joinGaiaLine2')}</p>
                <H6>{staticText.get('joinGaiaLine3')}</H6>
              </div>
              <Button
                className="share-page__video-limit-view-button"
                type={TYPES.ROYAL}
                url={URL_ACCOUNT_CREATION}
              >
                {staticText.get('joinGaia')}
              </Button>
            </>
          }
        </div>
      </div>
    </div>
  )
}

export default SharePageVideoLimitView
